<!-- <div class="rounded-xl border border-card-contrast bg-card p-4">
  <div class="flex items-center justify-between pb-3">
    <div>
      <div class="text-sm text-foreground-secondary">Your scheduled appointments</div>
      <div class="font-medium text-foreground">Upcoming Appointments</div>
    </div>
    <i class="pi pi-chart-line text-primary-500"></i>
  </div>

  <div class="space-y-3">
    <div
      *ngFor="let a of items"
      class="rounded-lg border border-card-contrast bg-card-elevated p-3 flex items-start gap-3 cursor-pointer hover:shadow-md hover:scale-105 transition-all ease-in"
      (click)="onClick(a)"
    >
      <div class="shrink-0 h-9 w-9 rounded-full bg-primary-100 dark:bg-primary-200/10 flex items-center justify-center text-primary-700 dark:text-primary-800">
        <i class="pi pi-user"></i>
      </div>
      <div class="flex-1 min-w-0">
        <div class="font-medium text-foreground truncate">{{ a.doctorName }}</div>
        <div class="text-sm text-foreground-secondary">{{ a.title }}</div>
        <div class="text-xs text-foreground-tertiary flex items-center gap-3 mt-1">
          <span class="flex items-center gap-1"><i class="pi pi-calendar"></i>{{ a.date }}</span>
          <span class="flex items-center gap-1"><i class="pi pi-clock"></i>{{ a.time }}</span>
        </div>
      </div>
      <span class="text-xs rounded-full px-2 py-1 bg-card-muted text-foreground-secondary">{{ a.status }}</span>
    </div>
  </div>
</div> -->

<!-- tailwind  -->
<!-- <div class="w-[370px] flex flex-col gap-4 shrink-0 bg-[#e5e5e5] rounded-xl p-4 dark:text-white">
  <h3 class="text-[1rem] font-semibold text-[#333] mb-2">Upcoming Consultation</h3>

  <div
    class="bg-white rounded-xl p-4 shadow-lg transition-transform hover:-translate-y-1 hover:shadow-xl dark:bg-gray-800 "
    *ngFor="let appt of items"
  >
    <div class="flex justify-between items-center mb-2">
      <h3 class="m-0 font-semibold text-[1.1rem]">{{ appt.title }}</h3>
      <span
        class="text-[0.85rem] font-medium px-2.5 py-1 rounded-xl text-white"
        [ngClass]="{
          'bg-[#007aff]': appt.status.toLowerCase() === 'upcoming',
          'bg-[#34c759]': appt.status.toLowerCase() === 'completed',
          'bg-[#ff3b30]': appt.status.toLowerCase() === 'cancelled'
        }"
      >
        {{ appt.status }}
      </span>
    </div>

    <div>
      <p class="my-1 text-[0.95rem] "><strong>Doctor:</strong> {{ appt.doctorName }}</p>
      <p class="my-1 text-[0.95rem] "><strong>Date:</strong> {{ appt.date }}</p>
      <p class="my-1 text-[0.95rem] "><strong>Time:</strong> {{ appt.time }}</p>
    </div>
  </div>
</div> -->

<!-- this is new as per punit  -->

<div class="flex flex-col gap-4 rounded-xl p-4 bg-card mt-3">
  <h3 class="text-xl font-semibold mb-2">Approved Appointments</h3>

  <div class="flex flex-wrap gap-4">
    <div *ngFor="let appointment of appointments" class="shadow-lg rounded-xl p-3">
      <!-- Doctor Section -->
      <div class="flex items-center gap-3 mb-3">
        <p-avatar
          icon="pi pi-user"
          shape="circle"
          size="large"
          styleClass="bg-blue-100 text-blue-600"
        ></p-avatar>

        <div>
          <div class="font-semibold text-lg">Dr. {{ appointment.doctor_name }}</div>

          <div class="text-sm text-gray-500">Patient: {{ appointment.patient_name }}</div>
        </div>
      </div>

      <!-- Appointment Details -->
      <div class="space-y-2 text-sm">
        <div class="flex justify-between">
          <span class="text-gray-500">Date</span>
          <span class="font-medium">
            {{ appointment.appointment_date | date: 'mediumDate' }}
          </span>
        </div>

        <div class="flex justify-between">
          <span class="text-gray-500">Time</span>
          <span class="font-medium">
            {{ appointment.slot_time }}
          </span>
        </div>

        <div class="flex justify-between">
          <span class="text-gray-500">Amount</span>
          <span class="font-medium text-green-600"> ₹{{ appointment.amount }} </span>
        </div>
      </div>

      <!-- Status + Join -->
      <div class="flex justify-between items-center">
        <p-tag
          value="Confirmed"
          severity="success"
          *ngIf="appointment.appointment_status === 105"
        ></p-tag>

        <p-tag
          value="Completed"
          severity="info"
          *ngIf="appointment.appointment_status === 110"
        ></p-tag>

        <p-tag
          value="Cancelled"
          severity="danger"
          *ngIf="appointment.appointment_status === 115"
        ></p-tag>

        <!-- Join Button -->
        <p-button
          type="button"
          label="Join"
          icon="pi pi-video"
          *ngIf="appointment.appointment_status === 105"
          (click)="joinAppointment(appointment)"
        ></p-button>
      </div>
    </div>
  </div>
</div>
